 setInterval(function () {
   const buttons = document.querySelectorAll(".single-add-to-cart-button--text");
   for (let i = 0; i < buttons.length; i++) {
     const button = buttons[i];
     const html = button.innerHTML;
     if (html === "Sold out") {
       button.parentNode.classList.add("soldout_button");
     } else {
       button.parentNode.classList.remove("soldout_button");
     }
   }
 });

(function () {
  let attempts = 0;
  const maxAttempts = 40;

  const interval = setInterval(function () {
    attempts++;

    const srLink = document.querySelector(
      'a[data-acsb="sr-trigger"][data-acsb-sr-only="true"]'
    );

    const header = document.querySelector('#main-content');

    if (srLink && header) {
      header.prepend(srLink);

      clearInterval(interval);
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 500);
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.template-page .blog-post-detail table').forEach(function (table) {
    var firstRow = table.querySelector('tbody tr');
    if (!firstRow) return;
    firstRow.querySelectorAll('td').forEach(function (td) {
      var th = document.createElement('th');

      Array.from(td.attributes).forEach(function (attr) {
        th.setAttribute(attr.name, attr.value);
      });

      th.innerHTML = td.innerHTML;
      td.replaceWith(th);
    });
  });

  document
    .querySelectorAll('.template-page .blog-post-detail table h3')
    .forEach(function (h3) {
      var h2 = document.createElement('h2');

      Array.from(h3.attributes).forEach(function (attr) {
        h2.setAttribute(attr.name, attr.value);
      });

      h2.innerHTML = h3.innerHTML;
      h3.replaceWith(h2);
    });
});

document.querySelectorAll('table').forEach((table) => {
  const firstRow = table.querySelector('tbody > tr:first-child');

  if (!firstRow) return;

  const headerCell = firstRow.querySelector('th[colspan]');
  const heading = headerCell?.querySelector('h3');

  if (!headerCell || !heading) return;

  const captionText = heading.textContent.trim();

  if (!captionText) return;

  const caption = document.createElement('caption');
  caption.textContent = captionText;

  table.insertBefore(caption, table.firstChild);
  firstRow.remove();
});
 (function () {
    function removeUnknownInputs() {
      document.querySelectorAll('input[aria-label="UNKNOWN"]').forEach(function (input) {
        input.remove();
      });
    }

    removeUnknownInputs();

    new MutationObserver(removeUnknownInputs).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();


  (function () {
  function removeFooterInput() {
    document
      .querySelectorAll('input[aria-label="ftr-tmp-input"]')
      .forEach(function (input) {
        input.remove();
      });
  }

  removeFooterInput();

  var observer = new MutationObserver(function () {
    removeFooterInput();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener('DOMContentLoaded', function () {
 document
    .querySelectorAll('.template-page-contact .section-footer .signup-container #contact_form')
    .forEach(function (form) {
      form.id = 'contact_form_footer';
    });
 });